import React from 'react';

import Router, { useRouter } from 'next/router';

import NProgress from 'nprogress';

import { Layout } from '../components/Layout/Layout';

import utm from '../utils/utm';
import { setLandingPage } from '../utils/cookies.js';

import '../styles/global/global.scss';

Router.events.on('routeChangeStart', () => NProgress.start());

Router.events.on('routeChangeComplete', (url) => {
  // since browsers are smart enough to identify the scroll position resetting it to (x,y)(0,0)
  window.scroll(0, 0);
  NProgress.done();
  (window as any).dataLayer &&
    (window as any).dataLayer.push({
      routeName: url.split('/')[1],
      pageType: 'pageview',
      pageUrl: url,
      pageTitle: (typeof document !== 'undefined' && document.title) || '',
      event: 'pageview',
    });
});

Router.events.on('routeChangeError', () => NProgress.done());

export default function App({ Component, pageProps }) {
  const { basePath, asPath, pathname } = useRouter();

  React.useEffect(() => {
    utm.create();

    if (pathname && pathname !== '/404' && pathname !== '/_error') {
      setLandingPage(basePath, asPath);
    }
  }, []);

  return (
    <Layout>
      <Component {...pageProps} />
    </Layout>
  );
}
